import { render, staticRenderFns } from "./ResourceTable.vue?vue&type=template&id=0bb574f5&scoped=true&"
import script from "./ResourceTable.js?vue&type=script&lang=js&"
export * from "./ResourceTable.js?vue&type=script&lang=js&"
import style0 from "./ResourceTable.vue?vue&type=style&index=0&id=0bb574f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb574f5",
  null
  
)

export default component.exports